import React from 'react';
import hotToast from 'react-hot-toast/headless';
import { runIfFn } from '../utils/index.js';
import { ToastComponent } from './ToastComponent.js';
export const toast = (options) => {
    const { title, description, icon, status, custom, duration } = options;
    if (custom) {
        return hotToast.custom(t => (React.createElement(ToastComponent, { onClose: () => hotToast.dismiss(t.id), status: status }, runIfFn(custom, {
            onClose: () => hotToast.dismiss(t.id),
        }))), {
            duration,
        });
    }
    return hotToast.custom(t => (React.createElement(ToastComponent, { onClose: () => hotToast.dismiss(t.id), status: status },
        React.createElement(ToastComponent.Content, { title: title, description: description, icon: icon }))), {
        duration,
    });
};
//# sourceMappingURL=toast.js.map